import {gql} from '@apollo/client';
import {COMPETITOR_FRAGMENT} from '../fragments';

export const SAVE_RESULT = gql`
  mutation saveResult($tournamentId: ID!, $round: [ResultInput]!) {
    saveResult(tournamentId: $tournamentId, round: $round) {
      table {
        place
        groupNumber
        members {
          clubId
          fullName
          address {
            country
            state
            city
          }
          phoneNumber
        }
        gamesPlayed
        matchesWon
        matchesLose
        matchDifference
        pointsInFavor
        pointsAgainst
        pointDifference
        opponents
        rounds {
          tableNumber
          competitorOne {
            name
            result
          }
          competitorTwo {
            name
            result
          }
        }
      }
      tournamentId
    }
  }
`;

export const UPDATE_LAST_ROUND = gql`
  mutation updateLastRound($tournamentId: ID!, $result: Test!) {
    updateLastRound(tournamentId: $tournamentId, result: $result)
  }
`;

export const CREATE_GROUP = gql`
  ${COMPETITOR_FRAGMENT}
  mutation createGroup($members: [MembersInput]!, $tournamentId: ID!) {
    createGroup(members: $members, tournamentId: $tournamentId) {
      table {
        ...CompetitorParts
      }
      tournamentId
    }
  }
`;

export const DELETE_GROUP = gql`
  mutation deleteGroup($tournamentId: ID!, $groupNumber: Int!) {
    deleteGroup(tournamentId: $tournamentId, groupNumber: $groupNumber) {
      tournamentId
    }
  }
`;
